export const REF_MARKER_KEY = "ref_marker";

export const getRefMarker = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(REF_MARKER_KEY);
};

export const appendRefMarkers = (url: string): string => {
  const urlParams = new URLSearchParams(window.location.search);
  const refMarker = getRefMarker();

  if (!refMarker) return url;

  if (url.startsWith("http://") || url.startsWith("https://")) {
    const urlWithParams = new URL(url);
    urlParams.forEach((value, key) => {
      urlWithParams.searchParams.append(key, value);
    });
    return urlWithParams.toString();
  } else {
    const baseUrl = new URL(window.location.origin + url);
    urlParams.forEach((value, key) => {
      baseUrl.searchParams.append(key, value);
    });

    return baseUrl.pathname + baseUrl.search;
  }
};
